// Client for the widget API (app/controllers/api/v1/widget), called cross-origin from the host page.
export const createApi = ({ baseUrl, websiteToken }) => {
  let authToken = null;

  const request = async (method, path, body) => {
    const url = new URL(path, baseUrl);
    url.searchParams.set('website_token', websiteToken);
    const headers = { Accept: 'application/json' };
    if (body) headers['Content-Type'] = 'application/json';
    if (authToken) headers['X-Auth-Token'] = authToken;

    const response = await fetch(url, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {
      const error = new Error(
        `Widget API ${method} ${path} failed with ${response.status}`
      );
      error.status = response.status;
      throw error;
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
  };

  return {
    setAuthToken: token => {
      authToken = token;
    },
    appearance: () => request('GET', '/api/v1/widget/appearance'),
    // Creates the contact on first call; with a stored token it re-issues one for the same visitor.
    config: () => request('POST', '/api/v1/widget/config'),
    messages: () => request('GET', '/api/v1/widget/messages'),
    sendMessage: ({ content, echoId }) =>
      request('POST', '/api/v1/widget/messages', {
        message: {
          content,
          echo_id: echoId,
          timestamp: new Date().toString(),
          referer_url: window.location.href,
        },
      }),
    // Menus are answered the way the classic widget does it: submitted_values on the outgoing input_select.
    submitChoice: (messageId, option) =>
      request('PATCH', `/api/v1/widget/messages/${messageId}`, {
        message: {
          submitted_values: [{ title: option.title, value: option.value }],
        },
      }),
    markSeen: () =>
      request('POST', '/api/v1/widget/conversations/update_last_seen'),
  };
};
